<template>
  <div>
    <div v-if="gamificationLoading" class="cart-gamification">
      <div class="cart-gamification__body cart-gamification__body--loading">
        <three-dots-loading />
      </div>
    </div>
    <div v-else-if="gamificationError" class="cart-gamification">
      <p>
        {{ $t('cart.cart_gamification.fetch_error') }}
        <a rel="nofollow" @click.prevent="retry">{{
          $t('cart.cart_gamification.try_fetch')
        }}</a>
      </p>
    </div>
    <transition name="fade">
      <div
        v-if="!gamificationLoading && !gamificationError && gamificationMessage"
        :class="['cart-gamification', { promotion: isPromotion }]"
      >
        <div class="cart-gamification__icon-wrapper">
          <gift-box
            :color="giftBoxColor"
            class="cart-gamification__gift-icon"
          />
        </div>
        <div class="cart-gamification__body">
          {{ gamificationMessage }}
          <div class="progress cart-gamification__progress">
            <promo-event-bar
              :class="[{ disable: isPromotion }]"
              :progress="gamificationAchieved"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ThreeDotsLoading from '~/components/loadings/three-dots'
import GiftBox from '~/components/icons/gift-box/GiftBox'
import PromoEventBar from '~/components/promo-event-bar/PromoEventBar'

export default {
  name: 'CartGamification',
  components: {
    ThreeDotsLoading,
    GiftBox,
    PromoEventBar,
  },
  props: {
    isPromotion: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    giftBoxColor() {
      return this.isPromotion ? '#FFF' : '#555'
    },
    gamification() {
      return this.$store.state.gamification.gamification
    },
    gamificationError() {
      return this.$store.state.gamification.error
    },
    gamificationLoading() {
      return this.$store.state.gamification.loading
    },
    gamificationMessage() {
      return this.gamification?.title
    },
    gamificationAchieved() {
      return this.gamification?.achieved
    },
  },
  methods: {
    retry() {
      this.$store.dispatch('gamification/updateGamification', {
        orderNumber: this.$store.state.orderNumber,
        storeInfo: this.$store.getters.storeInfo,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-gamification {
  padding: 15px;
  margin: 0 -15px;
  background-color: #f9f9fd;
  min-height: 86px;
  position: relative;
  box-sizing: border-box;
}

.disable {
  display: none;
}

.cart-gamification__icon-wrapper {
  position: absolute;
  top: 50%;
  left: 15px;
  width: 26px;
  height: 26px;
  margin-top: -14px;
  text-align: center;
}

.cart-gamification__body {
  margin-left: 42px;
  font-size: 13px;
  line-height: 1.3;
}

.cart-gamification.promotion {
  background-color: #4ac96d;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.cart-gamification__body--loading {
  width: 75%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 45px;
}

.cart-gamification__progress {
  margin-top: 5px;
}

@media (min-width: $screen_large) {
  .cart-gamification {
    margin: 0;
    padding: 20px;
    border-bottom: 1px solid #e6e6ea;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-color: #f6f6fa;
  }
  .cart-gamification__icon-wrapper {
    left: 20px;
  }
}

.cart-gamification__progress {
  > div {
    height: 8px;
  }
}

.cart-gamification__gift-icon {
  width: 25px;
  height: 25px;
}
</style>
